var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"content-container",class:{ plus: _vm.increasePadding, shadow: _vm.addImageShadow, clamped: _vm.contentClamped, formatContent: _vm.formatContent },attrs:{"id":_setup.docId},domProps:{"innerHTML":_vm._s(_setup.sourceContent)},on:{"click":_setup.handleClick}})
}
var staticRenderFns = []

export { render, staticRenderFns }